<template>
  <a-modal
    :title="`查看运行日志（计划名称：${planName}，计划版本：${planVersion}）`"
    :width="1200"
    :visible="visible"
    @cancel="close"
    :footer="null"
  >
    <div class="content">
      <div v-for="(item, index) in dataList" :key="item.id" :class="['pb30', { 'pt20': index !== 0 }]">
        <div class="align-center">
          <div class="stage-w min-w110 pr10">阶段：{{ item.stageNumber }}
            <a v-show="!item.show" class="align-center" @click="getDetail(item, index)">[显示日志]<a-icon :type="item.loading ? 'loading' : ''" class="ml5" /></a>
            <a v-show="item.show" @click="getDetail(item, index)">[隐藏日志]</a>
          </div>
          <div class="min-w210 pr10">程序名称：{{ item.stageCodeName }}</div>
          <div class="min-w140 pr10">运行状态：{{ item.statusName }}</div>
          <div class="min-w230 pr10">开始时间：{{ item.actualStartDate }}</div>
          <div class="min-w230 pr10">完成时间：{{ item.actualCompletionDate }}</div>
          <div class="min-w100">耗时：{{ item.timeInterval }}</div>
        </div>
        <div v-show="item.show" class="mt20">
          <div v-for="items in item.list" :key="items.id" class="detail-item">
            <div class="min-w110"></div>
            <div class="min-w110 pr10">步骤：{{ items.stepName }}</div>
            <div class="min-w140 pr10">{{ items.stepCode }}</div>
            <div class="min-w150 pr10">{{ items.actualStartDate }}</div>
            <div>{{ items.log }}</div>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { apiScpMrpPlanLogsDetails, apiScpMrpPlanStagesPlanRunFrame, apiScpMrpPlansLatestVersion } from '@/api/scp/factoryCallMaterial/runCallMaterialPlan'
// 表单字段
export default {
  props: {},
  data () {
    return {
      visible: false,
      dataList: [],
      planName: "", // 计划名称
      planVersion: "" // 计划版本
    }
  },
  created () {},
  methods: {
    // 加载日志详情
    getDetail (item, index) {
      const arr = JSON.parse(JSON.stringify(this.dataList))
      if (item.show) {
        arr[index].show = false
        this.dataList = arr
        return
      }
      arr[index].loading = true
      this.dataList = arr
      apiScpMrpPlanLogsDetails({ planName: this.planName, planVersion: this.planVersion, stageNumber: item.stageNumber }).then((response) => {
        if (response.code === 200) {
          arr[index].list = response.data
          arr[index].show = true
          arr[index].loading = false
          this.dataList = arr
        }
      })
    },
    show (queryParams, val) {
      this.planName = queryParams.planName
      this.visible = true
      apiScpMrpPlansLatestVersion({ planName: this.planName }).then((response) => {
        if (response.code === 200) {
          this.planVersion = val ? queryParams.planVersion : response.data
          apiScpMrpPlanStagesPlanRunFrame({ planName: this.planName, planVersion: this.planVersion }).then((res) => {
            if (res.code === 200) {
              const arr = res.data
              arr.forEach(element => {
                element.timeInterval = this.standardGetInervalSecond(element.actualStartDate, element.actualCompletionDate) // 耗时
                element.loading = false // 显示-加载状态
                element.show = false // 显示隐藏
                element.list = [] // 详情
              });
              this.dataList = arr
            }
          })
        }
      })
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 表单重置
    reset () {},
    // 计算时间差(秒)
    standardGetInervalSecond (startDate, endDate) {
      const ms = new Date(endDate).getTime() - new Date(startDate).getTime();
      return ms >= 0 ? `${ms / 1000}秒` : "";
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-modal-body {
  height: 450px;
  overflow-y: scroll;
}
.min-w230{
  min-width: 230px;
}
.min-w210{
  min-width: 210px;
}
.min-w150{
  min-width: 150px;
}
.min-w140{
  min-width: 140px;
}
.min-w110{
  min-width: 110px;
}
.min-w100{
  min-width: 100px;
}
.content {
  .stage-w {
    position: relative;
    a {
      position: absolute;
      left: 0px;
      top: 20px;
    }
  }
}
.detail-item{
  display: flex;
}
</style>
